<p><small>Percentiles de {{min}} a {{max}}</small></p>
<div class="percentile-container" [ngClass]="display">
    <div class="percentile" *ngFor="let percentile of percentileScale">
        <div class="color" [style.backgroundColor]="percentile.color"></div>
        <div class="text">{{percentile.value}}</div>
    </div>

</div>